import { styled } from '../../styled';

import { Flex, mediaBreakpointMixin, spaceMixin, Text, token } from '@zillow/constellation';

export const StyledBlueWrapper = styled.div`
  background-color: ${token('colors.backgroundDarkBlue')};
  width: 100%;
`;

export const StyledContainer = styled(Flex)`
  padding: ${spaceMixin('lg')};
`;
export const StyledImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  @media ${mediaBreakpointMixin('lg')} {
    margin-right: ${spaceMixin('lg')};
    margin-bottom: 0;
    max-width: 30%;
  }
`;

export const StyledImage = styled.img`
  max-width: 100%;
`;

export const StyledTextContainer = styled(Flex)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  padding-top: ${spaceMixin('lg')};

  @media ${mediaBreakpointMixin('md')} {
    justify-content: center;
    text-align: center;
  }

  @media ${mediaBreakpointMixin('lg')} {
    padding-top: 0;
    margin: 0;
    text-align: left;
    justify-content: flex-start;
  }
`;

export const StyledCaption = styled(Text)`
  margin: ${spaceMixin('xs')} auto;
  text-align: left;

  @media ${mediaBreakpointMixin('md')} {
    text-align: center;
  }

  @media ${mediaBreakpointMixin('lg')} {
    text-align: left;
    max-width: 100%;
  }
`;

export const StyledInline = styled.div`
  display: inline-block;
  margin: ${spaceMixin('xs')} 0 0 0;
`;
